import { administratorRoles } from "../../config/roles";
import { Update } from "../../api/recordService";
import { isFailedResponse } from "../../api/request";
import { RelatedTableActions } from "../relatedTableActions.types";
import { AddAccountContactAction } from "./AddAccountContactAction";

function contactName(row: Record<string, unknown>) {
  return String(row.fullname ?? row.name ?? "this contact");
}

// The same roles the old account form gave adding and removing contacts to.
export const accountRelatedTableActions: Record<string, RelatedTableActions> = {
  contact: {
    roles: administratorRoles,
    add: AddAccountContactAction,
    remove: {
      label: (row) => `Remove ${contactName(row)} from the account`,
      confirmation: (row) => ({
        title: "Remove from account",
        confirmText: "Remove",
        message: `Are you sure you want to remove ${contactName(
          row
        )} from this account? The contact is not deleted.`,
      }),
      // Through the account's own update, which unlinks the contact; the service
      // wants the account's name with it.
      remove: async (globalDispatch, parentId, row, parent) => {
        const name = String(parent.name ?? "");

        return !isFailedResponse(
          await Update(
            globalDispatch,
            "Contact removed",
            {
              Id: parentId,
              Name: name,
              Attributes: {
                name,
                "accountcontact-recordstoremove": [{ Id: row.id }],
              },
            },
            "account"
          )
        );
      },
    },
  },
};
